/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ares_Not_FoundInputs */

const cs_ares_not_found = /** @type {(inputs: Ares_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firma nenalezena.`)
};

const en_ares_not_found = /** @type {(inputs: Ares_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company not found.`)
};

/**
* | output |
* | --- |
* | "Company not found." |
*
* @param {Ares_Not_FoundInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ares_not_found = /** @type {((inputs?: Ares_Not_FoundInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ares_Not_FoundInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ares_not_found(inputs)
	return cs_ares_not_found(inputs)
});